export default (function (dir, target) { return new RegExp(dir, 'i').test(target); });
